const style = {
  table: {
    sx: { minWidth: 700 },
    loading: {
      opacity: 0.5,
    },
  },
  pagination: {
    component: 'div',
  },
} as const;

export default style;
